var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        viewBox: "0 0 206 179",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M49.5373 68.8933L48.0469 63.3314C47.1339 59.9239 48.1011 56.2825 50.5525 53.7996V53.7996C53.0003 51.3203 56.6157 50.3415 59.9937 51.2698V51.2698C63.3718 52.1981 66.0178 54.8694 66.9295 58.2718L67.049 58.7178C67.9122 61.9394 67.2266 65.3654 65.1973 67.97L63.5863 70.0379",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M110.028 52.6848L108.538 47.1229C107.625 43.7154 108.592 40.074 111.043 37.5911V37.5911C113.491 35.1118 117.107 34.133 120.485 35.0613V35.0613C123.863 35.9896 126.509 38.6609 127.42 42.0633L127.54 42.5093C128.403 45.7309 127.717 49.1569 125.688 51.7615L124.077 53.8294",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M79.7823 60.7889L78.2919 55.2269C77.3789 51.8194 78.3461 48.178 80.7975 45.6951V45.6951C83.2453 43.2158 86.8607 42.237 90.2387 43.1653V43.1653C93.6168 44.0936 96.2628 46.7649 97.1745 50.1673L97.294 50.6133C98.1572 53.8349 97.4716 57.2609 95.4423 59.8655L93.8313 61.9334",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M37.7657 62.6338L124.578 39.3725L138.863 44.6281L158.42 118.514L67.7017 143.255L66.4329 138.814L60.8336 139.859L60.0889 136.277L54.3794 137.546L37.7657 62.6338Z",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M39.7023 63.7527L48.1991 66.9359",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M46.6892 78.8067L48.5675 89.8779M53.0083 101.297L57.4491 122.232",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M56.1793 84.8022L67.6163 136.534",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M54.707 67.3351L138.884 44.78L143.918 63.5665L168.818 119.898L84.6415 142.454L59.7409 86.1216L54.707 67.3351Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M58.4864 51.008L59.4554 51.2531C63.154 52.1885 66.0724 55.0758 67.0654 58.7819V58.7819C67.9178 61.963 67.2408 65.3458 65.2371 67.9177L63.5855 70.0377",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M118.977 34.7995L119.946 35.0446C123.645 35.98 126.563 38.8673 127.556 42.5735V42.5735C128.409 45.7545 127.732 49.1373 125.728 51.7092L124.076 53.8292",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M88.7322 42.904L89.7013 43.1491C93.3999 44.0845 96.3182 46.9718 97.3113 50.6779V50.6779C98.1637 53.859 97.4867 57.2418 95.483 59.8137L93.8314 61.9336",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          x1: "70.1108",
          y1: "81.1982",
          x2: "137.985",
          y2: "63.0115",
          stroke: "white",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          x1: "77.0813",
          y1: "97.5174",
          x2: "144.955",
          y2: "79.3307",
          stroke: "white",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("line", {
        attrs: {
          x1: "82.2788",
          y1: "116.91",
          x2: "150.153",
          y2: "98.7233",
          stroke: "white",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M77.3564 79.2254L101.667 131.169M98.5858 73.5369L122.896 125.48M121.009 67.5289L145.319 119.472",
          stroke: "white",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M149.944 46.2166C157.613 46.8967 162.992 49.3651 165.074 53.7383C171.377 66.9843 145.037 92.6897 106.24 111.153C67.443 129.616 30.8819 133.846 24.5781 120.6C21.2615 113.631 26.9814 103.213 38.7975 92.2148",
          stroke: "black",
          "stroke-width": "2.88747"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M156.602 51.7949L167.49 51.4962L175.793 59.7449L174.191 71.9569L163.476 77.4464L153.553 72.25L150.607 61.2565L156.602 51.7949Z",
          fill: "#EEA71F"
        }
      }),
      _vm._v(" "),
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "alpha" },
          attrs: {
            id: "mask0_428_9959",
            maskUnits: "userSpaceOnUse",
            x: "150",
            y: "51",
            width: "26",
            height: "27"
          }
        },
        [
          _c("path", {
            attrs: {
              d:
                "M156.602 51.7949L167.49 51.4962L175.793 59.7449L174.191 71.9569L163.476 77.4464L153.553 72.25L150.607 61.2565L156.602 51.7949Z",
              fill: "#2C6FEF"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c("g", { attrs: { mask: "url(#mask0_428_9959)" } }, [
        _c("path", {
          attrs: {
            d:
              "M165.059 58.0797L170.251 52.7223L174.403 56.8465L174.133 64.5438L170.784 65.7656L167.922 61.9227L164.295 61.3234L165.059 58.0797Z",
            fill: "#535353"
          }
        })
      ]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M167.767 65.5958L166.619 69.4681L168.821 72.1186L167.121 74.3351L160.083 70.2234L165.35 65.8584L167.767 65.5958Z",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M155.551 55.4539L160.989 55.3596L158.089 62.6733L161.398 70.6218L152.731 69.1979L151.422 64.3119L153.91 60.4182L155.551 55.4539Z",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M175.416 37.5888L179.834 39.4618L179.675 44.4506L175.158 45.6608L172.526 41.42L175.416 37.5888Z",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "169.917",
          y: "91.194",
          width: "3.81284",
          height: "3.81284",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "68.8344",
          y: "24.1716",
          width: "2.54189",
          height: "2.54189",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "97.4012",
          y: "31.8627",
          width: "3.81284",
          height: "3.81284",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "16.0957",
          y: "71.4166",
          width: "3.81284",
          height: "3.81284",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "34.7743",
          y: "116.465",
          width: "2.54189",
          height: "2.54189",
          fill: "#535353"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "129.264",
          y: "137.34",
          width: "2.54189",
          height: "2.54189",
          fill: "#535353"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }